/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const mobileOrderAppliedComboSchema = z
	.object({
		id: z.uuid(),
		name: z.string(),
		amount: z.int().min(-2147483648).max(2147483647),
		price: z.number(),
	})
	.describe("Сериализатор для примененного комбо в заказе.");
